const days = ["Sunday", "Monday", "Tuesday", "Wedenesday", "Thursday", "Friday", "Saturday"],
  months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  milliSecondsOf24Hr = 86400000;
export const formatDateTime = (timestamp: number | string) => {
  let retDateTimeStr: string = "";
  timestamp = parseFloat(timestamp.toString());
  timestamp = new Date(new Date(timestamp).toISOString()).getTime();

  const compareTimestamp = new Date(timestamp).setHours(0, 0, 0, 0);

  if (timestamp > 0) {
    const currTimestamp = new Date().getTime(),
      dateObj = new Date(timestamp);
    switch (true) {
      case currTimestamp - compareTimestamp <= milliSecondsOf24Hr: // less than a day
        retDateTimeStr = "Today";
        break;
      case currTimestamp - compareTimestamp > milliSecondsOf24Hr && currTimestamp - compareTimestamp <= returnMilliSeconds(2): // more than 24 hours and less than 48 hours
        retDateTimeStr = "Yesterday";// + (dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours()) + ":" + (dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes());
        break;
      case currTimestamp - compareTimestamp > returnMilliSeconds(2) && currTimestamp - compareTimestamp <= returnMilliSeconds(7): // more than 48 hours and less than 7 days
        retDateTimeStr = days[dateObj.getDay()];// + " " + (dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours()) + ":" + (dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes());
        break;
      case currTimestamp - compareTimestamp > returnMilliSeconds(7) && currTimestamp - compareTimestamp <= returnMilliSeconds(365): // more than 7 days and less than 1 year
        retDateTimeStr = dateObj.getDate() + " " + months[dateObj.getMonth()];// + " at " + (dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours()) + ":" + (dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes());
        break;
      case currTimestamp - compareTimestamp > returnMilliSeconds(365): // more than 1 year
        retDateTimeStr = dateObj.getDate() + " " + months[dateObj.getMonth()] + " " + dateObj.getFullYear();// + " at " + (dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours()) + ":" + (dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes());
        break;
    }
  }
  return retDateTimeStr;
};

export const formatDateTimeMessage = (timestamp: number | string) => {
  let retDateTimeStr: string = "";
  timestamp = parseFloat(timestamp.toString());
  timestamp = new Date(new Date(timestamp).toISOString()).getTime();

  if (timestamp > 0) {
    const dateObj = new Date(timestamp);
      retDateTimeStr = (dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours()) + ":" + (dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes());
  }
  return retDateTimeStr;
};

const returnMilliSeconds = (days: number) => {
  return days * milliSecondsOf24Hr;
};

export function formatDate(timestamp: number | string) {
  timestamp = parseFloat(timestamp.toString());
  timestamp = new Date(timestamp).getTime();

  const difference: number = new Date().getTime() - new Date(timestamp).getTime(),
    //Arrange the difference of date in days, hours, minutes, and seconds format
    years = Math.floor(difference / (1000 * 60 * 60 * 24 * 365)),
    weeks = Math.floor(difference / (1000 * 60 * 60 * 24 * 7)),
    days = Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
    seconds = Math.floor((difference % (1000 * 60)) / 1000);

  if (years && years > 0) {
    return years + "y";
  }
  if (weeks && weeks > 0) {
    return weeks + "w";
  }
  if (days && days > 0) {
    return days + "d";
  }
  if (hours && hours > 0) {
    return hours + "h";
  }
  if (minutes && minutes > 0) {
    return minutes + "m";
  }
  if (seconds >= 0) {
    return "Now";
  }
}
